<template>
  <button
    type="button"
    class="v1-chip"
    :class="{ 'v1-chip--selected': selected }"
    @click="$emit('select')"
  >
    {{ label }}
  </button>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "V1AmountChip",
  props: {
    label: { type: String, required: true },
    selected: { type: Boolean, default: false },
  },
  emits: ["select"],
});
</script>

<style scoped>
.v1-chip {
  box-sizing: border-box;
  width: auto;
  padding: 8px 12px;
  border: 1px solid var(--pj-color-brand-gray-350, #c6c7bf);
  border-radius: var(--pj-radius-pill, 999px);
  background: transparent;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.5px;
  color: var(--pj-color-brand-gray-850, #222926);
  cursor: pointer;
  text-align: center;
  white-space: nowrap;
}

.v1-chip--selected {
  padding: 7px 11px;
  border-width: 2px;
  border-color: var(--pj-color-brand-gray-850, #222926);
}
</style>
